var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimerClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1108_13818)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6308 9.03503C13.9355 8.73047 13.9355 8.23639 13.6308 7.93167C13.3261 7.62695 12.832 7.62695 12.5273 7.93167L9.46335 10.9958C9.15863 11.3004 9.15863 11.7944 9.46335 12.0992C9.76791 12.4039 10.262 12.4039 10.5667 12.0992L13.6308 9.03503Z",
    fill: "#2D3958"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4149 5.04425C14.0993 3.94806 12.5006 3.28583 10.7953 3.1308V1.56052H11.5495C11.9804 1.56052 12.3297 1.21109 12.3297 0.780182C12.3297 0.349274 11.9804 0 11.5495 0H8.48053C8.04962 0 7.70035 0.349274 7.70035 0.780182C7.70035 1.21109 8.04962 1.56052 8.48053 1.56052H9.23477V3.1308C4.96597 3.51898 1.5625 7.1051 1.5625 11.5474C1.5625 16.219 5.34287 20 10.0151 20C14.6866 20 18.4676 16.2196 18.4676 11.5474C18.4676 9.55185 17.7803 7.66205 16.5183 6.14761L15.4149 5.04425ZM3.12286 11.5474C3.12286 15.3477 6.21475 18.4395 10.015 18.4395C13.8153 18.4395 16.907 15.3477 16.907 11.5474C16.907 7.74719 13.8153 4.65546 10.015 4.65546C6.21475 4.65546 3.12286 7.74719 3.12286 11.5474Z",
    fill: "#2D3958"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1108_13818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerClock);
export default __webpack_public_path__ + "static/media/timer-clock.fd5ef99b6a235d00380a50f4f8cf327d.svg";
export { ForwardRef as ReactComponent };